import React, { PureComponent } from 'react'
import i18n from 'i18next'
import Modal from './Modal'
import Button from './Button'

class ConfirmationModal extends PureComponent {
    render() {
        const {
            show, onClose, title, subtitle, description, onTrue, onFalse, onFalseLabel, onTrueLabel, onFalseCss, onTrueCss
        } = this.props
        return (
            <Modal show={show} onClose={onClose}>
                <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                    <h2>{title}</h2>
                    {subtitle && <h3>{subtitle}</h3>}
                    <div style={{ marginTop: '18px' }} dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <div style={{ display: 'flex', gap: '32px', justifyContent: 'center' }}>
                    {onFalse
                        && (
                            <Button
                                label={onFalseLabel || i18n.t('cancel')}
                                onClick={onFalse}
                                cssClass={`regular ${onFalseCss || 'tertiary'}`}
                                style={{ width: '78px' }}
                            />
                        )}
                    {onTrue
                        && (
                            <Button
                                label={onTrueLabel || i18n.t('gen_yes')}
                                onClick={onTrue}
                                cssClass={`regular ${onTrueCss || 'tertiary'}`}
                                style={{ width: '78px' }}
                            />
                        )}
                </div>
            </Modal>
        )
    }
}

export default ConfirmationModal
